<div class="notification-form">
  <form
    (ngSubmit)="sendNotification()"
    novalidate
    [formGroup]="notificationForm"
    (click)="qeFocusToggle($event)"
    >
    <div class="required">Required *</div>
    <div>
      <mat-form-field class="send-notification__title" fxFlex="90%">
        <label>
          <input
            matInput
            trimInput
            type="text"
            placeholder="Title*"
            formControlName="title"
            />
        </label>
        <mat-error
          print-error
          [control]="notificationForm?.get('title')"
          fieldName="Title"
          >
        </mat-error>
      </mat-form-field>
    </div>

    <div>
      <div class="quill-body" fxFlex="90%">
        <p
          class="quill-tip"
          id="quill-tip-text"
          [ngClass]="{ quillTipVis: quillTipBool }"
          >
          This editor uses the tab key for indenting. To move focus
          past the editor with the keyboard, use alt + Page Down.
        </p>
        <quill-editor
          placeholder="Message Body *"
          [required]="true"
          formControlName="body"
          (onContentChanged)="setBody($event)"
          (keyup)="qeKeyHandler($event)"
          >
          <div quill-editor-toolbar>
            <span class="ql-formats">
              <button
                class="ql-bold"
                [title]="'Bold'"
                [attr.aria-label]="'Bold'"
              ></button>
              <button
                class="ql-italic"
                [title]="'Italic'"
                [attr.aria-label]="'Italic'"
              ></button>
              <button
                class="ql-underline"
                [title]="'Underline'"
                [attr.aria-label]="'Underline'"
              ></button>
              <button
                class="ql-strike"
                [title]="'Strikethrough'"
                [attr.aria-label]="'Strikethrough'"
              ></button>
            </span>
            <span class="ql-formats">
              <button
                class="ql-header"
                value="1"
                [title]="'Heading 1'"
                [attr.aria-label]="'Heading 1'"
              ></button>
              <button
                class="ql-header"
                value="2"
                [title]="'Heading 2'"
                [attr.aria-label]="'Heading 2'"
              ></button>
            </span>
            <span class="ql-formats">
              <button
                class="ql-list"
                value="ordered"
                [title]="'Ordered List'"
                [attr.aria-label]="'Ordered List'"
              ></button>
              <button
                class="ql-list"
                value="bullet"
                [title]="'Unordered List'"
                [attr.aria-label]="'Unordered List'"
              ></button>
            </span>
            <span class="ql-formats">
              <button
                class="ql-indent"
                value="-1"
                [title]="'Outdent'"
                [attr.aria-label]="'Outdent'"
              ></button>
              <button
                class="ql-indent"
                value="+1"
                [title]="'Indent'"
                [attr.aria-label]="'Indent'"
              ></button>
            </span>
            <span class="ql-formats">
              <select
                class="ql-header"
                [title]="'Headings'"
                [attr.aria-label]="'Headings'"
                >
                <option selected></option>
                <option
                  value="1"
                  [title]="'heading 1'"
                ></option>
                <option
                  value="2"
                  [title]="'heading 2'"
                ></option>
                <option
                  value="3"
                  [title]="'heading 3'"
                ></option>
                <option
                  value="4"
                  [title]="'heading 4'"
                ></option>
                <option
                  value="5"
                  [title]="'heading 5'"
                ></option>
                <option
                  value="6"
                  [title]="'heading 6'"
                ></option>
              </select>
            </span>
            <span class="ql-formats">
              <button
                class="ql-link"
                [title]="'Link'"
                [attr.aria-label]="'Link'"
              ></button>
              <button
                class="ql-image"
                [title]="'Image'"
                [attr.aria-label]="'Image'"
              ></button>
              <button
                class="ql-video"
                [title]="'Video'"
                [attr.aria-label]="'Video'"
              ></button>
            </span>
            <span class="ql-formats">
              <select
                class="ql-align"
                [title]="'Text Alignment'"
                [attr.aria-label]="'Text Alignment'"
                >
                <option selected></option>
                <option
                  value="center"
                  [title]="'Center aligned'"
                  [attr.aria-label]="'Center aligned'"
                ></option>
                <option
                  value="right"
                  [title]="'Right aligned'"
                  [attr.aria-label]="'Right aligned'"
                ></option>
                <option
                  value="justify"
                  [title]="'Justify'"
                  [attr.aria-label]="'Justify'"
                ></option>
              </select>
            </span>
            <span class="ql-formats">
              <button
                class="ql-clean"
                [title]="'Remove Formatting'"
                [attr.aria-label]="'Remove Formatting'"
              ></button>
            </span>
          </div>
        </quill-editor>
        <mat-error
          print-error
          [control]="notificationForm?.get('body')"
          fieldName="Message Body"
          >
        </mat-error>
      </div>
    </div>

    <div
      class="dates-container"
      flex-wrap="wrap"
      fxLayout="row wrap"
      fxLayoutAlign="start center"
      >
      <!-- Display At -->
      <div
        class="send-notification__displayAt"
        style="margin-right: 12px"
        >
        <mat-form-field
          class="date-field"
          (click)="$event.stopPropagation()"
          >
          <p class="cdk-visually-hidden">
            The following input opens a datepicker with either enter
            or space. It can then be navigated using your arrow keys
            and tab.
          </p>
          <input
            matInput
            readonly
            placeholder="Display Date"
            formControlName="displayAt"
            [owlDateTimeTrigger]="displayDatePicker"
            [owlDateTime]="displayDatePicker"
            title="Navigate the datepicker using your arrow keys and tab"
            (keyup)="keyHandler($event)"
            />
          <owl-date-time
            #displayDatePicker
            [hour12Timer]="true"
            [stepMinute]="5"
            [panelClass]="'owlDatePickerPanel'"
          ></owl-date-time>
        </mat-form-field>
        <div class="optionalLabel">(Optional)</div>
      </div>

      <!-- Expire At -->
      <div class="send-notification__expireAt">
        <mat-form-field
          class="date-field"
          (click)="$event.stopPropagation()"
          >
          <p class="cdk-visually-hidden">
            The following input opens a datepicker with either enter
            or space. It can then be navigated using your arrow keys
            and tab.
          </p>
          <input
            matInput
            readonly
            placeholder="Expiration Date"
            formControlName="expireAt"
            [owlDateTimeTrigger]="expireDatePicker"
            [owlDateTime]="expireDatePicker"
            title="Navigate the datepicker using your arrow keys and tab"
            (keyup)="keyHandler($event)"
            />
          <owl-date-time
            #expireDatePicker
            [hour12Timer]="true"
            [stepMinute]="5"
            [panelClass]="'owlDatePickerPanel'"
          ></owl-date-time>
        </mat-form-field>
        <div class="optionalLabel">(Optional)</div>
      </div>

      @if (dateMismatch()) {
        <div class="dates-mismatch">
          *<span>Display</span> date needs to be <span>BEFORE</span> the
          <span>Expiration</span> date
        </div>
      }
    </div>

    <!-- Classes -->
    @if (isTeacher | async) {
      <div>
        <mat-form-field fxFlex="90%">
          <mat-select
            placeholder="Classes"
            formControlName="courses"
            multiple
            >
            @for (course of courses; track course) {
              <mat-option
                [value]="course.courseID"
                >{{ course.courseTitle }}
              </mat-option>
            }
          </mat-select>
          <mat-error
            print-error
            [control]="notificationForm?.get('teacher-classes')"
            fieldName="At least one class"
            >
          </mat-error>
        </mat-form-field>
      </div>
    }

    @if (isDistributor | async) {
      <div
        flex-wrap="wrap"
        fxLayout="row wrap"
        fxLayoutAlign="start center"
        >
        <div
          class="send-notification__sendToTeachers"
          style="margin-right: 12px"
          >
          <mat-checkbox formControlName="sendToTeachers"
            >Send to Teachers</mat-checkbox
            >
          </div>
          <div class="send-notification__sendToStudents">
            <mat-checkbox formControlName="sendToStudents"
              >Send to Students</mat-checkbox
              >
            </div>
          </div>
        }

        @if (isDistributor | async) {
          <div
            flex-wrap="wrap"
            fxLayout="row wrap"
            fxLayoutAlign="start center"
            >
            <mat-form-field style="margin-right: 12px">
              <mat-select
                placeholder="Send only to Program"
                formControlName="languages"
                >
                <mat-option value="" selected>Send to All</mat-option>
                @for (language of languages; track language) {
                  <mat-option
                    [value]="language.languageID"
                    >{{ language.languageName }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-select
                placeholder="Send only to Tiers"
                formControlName="tiers"
                >
                @for (tier of tiers; track tier) {
                  <mat-option [value]="tier.value"
                    >{{ tier.displayName }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }

        <mat-action-row>
          <div fxLayout="row" fxLayoutAlign="end" fxFill fxFlex="100">
            <button
              role="button"
              mat-raised-button
              color="primary"
              class="wide-button"
              type="submit"
              title="Submit"
                    [disabled]="
                        notificationForm?.invalid || working || dateMismatch()
                    "
              >
              <span class="send-liner">Send</span>
              <mat-icon aria-label="Send">send</mat-icon>
            </button>
          </div>
        </mat-action-row>
      </form>
    </div>
